// Remembers that the user pressed Save while signed out, so the click survives
// the trip to the login page and back instead of being silently dropped.
//
// The build itself needs no special handling: it already lives in localStorage
// under gixcore-current-build and is untouched by signing in. Only the intent
// is transient, so it goes in sessionStorage and is consumed exactly once.

const PENDING_SAVE_KEY = 'gixcore_pending_build_save'

const session = () => {
    try {
        return typeof window !== 'undefined' ? window.sessionStorage : null
    }
    catch(e){
        return null
    }
}

export function setPendingBuildSave(){
    var store = session()
    if(!store){ return }
    try { store.setItem(PENDING_SAVE_KEY, '1') } catch(e){ /* private mode */ }
}

// Reads and clears in one step: a resumed save must never fire twice.
export function consumePendingBuildSave(){
    var store = session()
    if(!store){ return false }
    try {
        var pending = store.getItem(PENDING_SAVE_KEY) === '1'
        if(pending){ store.removeItem(PENDING_SAVE_KEY) }
        return pending
    }
    catch(e){
        return false
    }
}

export function clearPendingBuildSave(){
    var store = session()
    if(!store){ return }
    try { store.removeItem(PENDING_SAVE_KEY) } catch(e){ /* private mode */ }
}
